import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../../sessionStorage";
import { ONE_CLICK_PRODUCT_TYPE_ID } from "../../../../types/sharedConstants";
import States from "../../../Helpers/Lists/States";
import { coverageTypeOptions, illustrationTypeConstant } from "../../RequestIllustration/Helper/Constant";

export const CustomerType = {
  "USBank": 300,
  "USBankDemo": 301,
  "Cetera": 400,
  "CeteraDemo": 401,
  "CeteraSpecialist": 402,
  "CeteraSpecialistDemo": 403,
  "KeyBank": 1000,
  "KeyBankDemo": 1001,
  "CitizensBank": 4000,
  "CitizensBankDemo": 4001,
  "IndependentAgent": 7000,
  "UnionBank": 2000,
  "UnionBankDemo": 2001,
  "AllState": 12000,
  "AllStateDemo": 12001,
}

export const CUSTOMER = {
  CETERA: "Cetera",
  CETERA_SPECIALIST: "CeteraSpecialist",
  KEY_BANK: "KeyBank",
  CITIZENS_BANK: "CitizensBank",
  US_BANK: "UsBank",
  UNION_BANK: "UnionBank",
  ALL_STATE: "AllState",
  INDEPENDENT_AGENT: "IndependentAgent",
}

// list of customer with their custom pages
export const CustomerPages = {
  [CUSTOMER.CETERA]: ['insurance-application-info'],
  [CUSTOMER.CITIZENS_BANK]: ['insurance-application-info'],
  [CUSTOMER.KEY_BANK]: ['insurance-application-info', 'product-suitability', 'product-switch-disclosure'],
  [CUSTOMER.US_BANK]: ['insurance-application-info', 'acknowledgement-disclosure', 'insurance-objective-info', 'source-of-fund', 'product-replacement-comparison'],
}

export function GetCustomer() {
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  switch (accountObj && accountObj.customerID) {
      case CustomerType.Cetera:
      case CustomerType.CeteraDemo:
          return CUSTOMER.CETERA;
      case CustomerType.CeteraSpecialist:
      case CustomerType.CeteraSpecialistDemo:
          return CUSTOMER.CETERA_SPECIALIST;
      case CustomerType.KeyBank:
      case CustomerType.KeyBankDemo:
          return CUSTOMER.KEY_BANK;
      case CustomerType.CitizensBank:
      case CustomerType.CitizensBankDemo:
          return CUSTOMER.CITIZENS_BANK;
      case CustomerType.USBank:
      case CustomerType.USBankDemo:
          return CUSTOMER.US_BANK;
      case CustomerType.UnionBank:
      case CustomerType.UnionBankDemo:
          return CUSTOMER.UNION_BANK;
      case CustomerType.AllState:
      case CustomerType.AllStateDemo:
          return CUSTOMER.ALL_STATE;
      case CustomerType.IndependentAgent:
          return CUSTOMER.INDEPENDENT_AGENT;
      default:
          return "";
  }
}
export const keyBankExcludeCustomFormProductList = [ONE_CLICK_PRODUCT_TYPE_ID.term, ONE_CLICK_PRODUCT_TYPE_ID.minnSLWL]

export const checkIsInsurancePage = (customer, productTypeID) => {
  let isInsurancePage = true;
  switch (customer) {
      case CUSTOMER.CETERA:
      case CUSTOMER.CETERA_SPECIALIST:
          isInsurancePage = false;
          break;
      case CUSTOMER.KEY_BANK:
          isInsurancePage = keyBankExcludeCustomFormProductList.includes(productTypeID);
          break;
      case CUSTOMER.CITIZENS_BANK:
      case CUSTOMER.US_BANK:
          isInsurancePage = productTypeID === ONE_CLICK_PRODUCT_TYPE_ID.minnSLWL;
          break;
      default:
          break;
  }
  return isInsurancePage
}

// Returns a list of approved states based on the customer and journey
//TODO: we will modify this funtion based on customer if needed
export const getApprovedStateList = () => {
    const mtUnapprovedStates = ['GU', 'PR'];
    return States(mtUnapprovedStates);
}

// Returns a list of approved coverage types for illustartion based on the customer
export const getCoverageTypeListForIllustration = () => {
    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    let coverageTypeList = coverageTypeOptions;
    
    // remove the unapproved coverage type options from the dropdown for Covrpro Account (ticket SWE-8848).
    if (accountObj && accountObj.isCovrproAccount) {
        const unapprovedCoverageTypeForCovrPro = [illustrationTypeConstant.VUL, illustrationTypeConstant.TraditionalLTC];
        coverageTypeList = coverageTypeOptions.filter((item) => !unapprovedCoverageTypeForCovrPro.includes(item.value));
    }
    
    switch (GetCustomer()) {
        case CUSTOMER.KEY_BANK:
            const keyBankUnapprovedCoverageType = [illustrationTypeConstant.VUL];
            return coverageTypeList.filter((item) => !keyBankUnapprovedCoverageType.includes(item.value));
        default:
            return coverageTypeList;
    }
}



// WEBPACK FOOTER //
// ./src/components/Product/Customer/Utilities/Customer.js